import React, { useState, useEffect, useMemo } from "react";

interface Props {
  text: string;
  regex: string;
  placeholder?: string;
  onTextAvailable: (e: string) => void;
}

const TableTextInput = ({ text: initialText, regex: regexStr, placeholder, onTextAvailable }: Props) => {
  const [text, setText] = useState(initialText ?? "");
  const [isValid, setIsValid] = useState(true);

  const regex = useMemo(() => new RegExp(regexStr), [regexStr]);

  useEffect(() => {
    setText(initialText ?? "");
  }, [initialText]);

  const validate = (value: string) => {
    const valid = regex.test(value);
    setIsValid(valid);
    return valid;
  };

  const handleBlurOrEnter = (value: string) => {
    if (validate(value)) {
      onTextAvailable(value);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleBlurOrEnter(e.currentTarget.value);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    setText(value);
    setIsValid(regex.test(value));
  };

  return (
    <div className="relative">
      <input
        type="text"
        placeholder={placeholder}
        className={`w-full mt-1 pl-1 text-gray-700 border rounded focus:outline-none ${
          isValid ? "border-slate-300 focus:ring focus:ring-sky-200" : "border-red-500"
        }`}
        value={text}
        onChange={handleChange}
        onBlur={(e) => handleBlurOrEnter(e.currentTarget.value)}
        onKeyDown={handleKeyDown}
        aria-invalid={!isValid}
      />
    </div>
  );
};

export default TableTextInput;
